<template>
  <div class="home">
    <v-header></v-header>
    <router-view></router-view>
    <v-footer></v-footer>
  </div>
</template>

<script>
// @ is an alias to /src
import Header from "./Header.vue";
import Footer from "./Footer.vue";

export default {
  name: "home",
  components: {
    'v-header':Header,
    'v-footer':Footer
  }
};
</script>



// WEBPACK FOOTER //
// src/views/Home.vue